module.exports = __webpack_public_path__ + "static/media/ir.7c8e6cb3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ir.svg
// module id = 855
// module chunks = 0